"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileDropButton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactDropzone = require("react-dropzone");
var _reactIntl = require("react-intl");
var _CloudUploadIcon, _CloudUploadIcon2;
var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    buttonTextLeftSpacing: {
      marginLeft: theme.spacing(1)
    },
    buttonTextRightSpacing: {
      marginRight: theme.spacing(1)
    },
    dropzone: {
      border: 'none',
      display: 'inline-flex'
    },
    dropzoneAccept: {
      '& button': {
        backgroundColor: theme.palette.primary.light,
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main
      }
    },
    dropzoneActive: {},
    dropzoneDisabled: {},
    dropzoneReject: {
      '& button': {
        backgroundColor: theme.palette.action.disabledBackground,
        borderColor: theme.palette.action.disabled,
        color: theme.palette.action.disabled,
        cursor: 'not-allowed'
      }
    }
  };
});
function FileDropButton(_ref) {
  var accept = _ref.accept,
    _ref$Component = _ref.Component,
    Component = _ref$Component === void 0 ? _material.Button : _ref$Component,
    _ref$componentProps = _ref.componentProps,
    componentProps = _ref$componentProps === void 0 ? {} : _ref$componentProps,
    disabled = _ref.disabled,
    _ref$iconPosition = _ref.iconPosition,
    iconPosition = _ref$iconPosition === void 0 ? 'right' : _ref$iconPosition,
    id = _ref.id,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    _onDrop = _ref.onDrop,
    textKey = _ref.textKey;
  var classes = useStyles();
  var _useDropzone = (0, _reactDropzone.useDropzone)({
      accept,
      disabled,
      multiple,
      onDrop: function onDrop(acceptedFiles, rejectedFiles) {
        if (rejectedFiles.length || !multiple && acceptedFiles.length + rejectedFiles.length > 1) {
          return false;
        }
        return _onDrop(acceptedFiles, rejectedFiles);
      }
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragAccept = _useDropzone.isDragAccept,
    isDragReject = _useDropzone.isDragReject;
  var iconOnLeft = iconPosition === 'left';
  var iconOnRight = iconPosition === 'right';
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    id: id
  }, getRootProps({
    className: (0, _classnames.default)(classes.dropzone, isDragActive && classes.dropzoneActive, isDragAccept && classes.dropzoneAccept, isDragReject && classes.dropzoneReject, disabled && classes.dropzoneDisabled)
  })), /*#__PURE__*/_react.default.createElement("input", getInputProps()), /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    color: "primary",
    id: "".concat(id, "UploadButton"),
    type: "button",
    variant: "contained"
  }, componentProps), iconOnLeft && (_CloudUploadIcon || (_CloudUploadIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.CloudUpload, {
    fontSize: "small"
  }))), textKey && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)({
      [classes.buttonTextRightSpacing]: iconOnRight,
      [classes.buttonTextLeftSpacing]: iconOnLeft
    })
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: textKey
  })), iconOnRight && (_CloudUploadIcon2 || (_CloudUploadIcon2 = /*#__PURE__*/_react.default.createElement(_iconsMaterial.CloudUpload, {
    fontSize: "small"
  })))));
}